import { css } from '@/styled-system/css';

export const cardBlockAnchorStyles = css.raw({
  position: 'absolute',
  inset: 0,
  zIndex: 0,
  borderRadius: 'inherit',

  _focusVisible: {
    boxShadow: 'focus',
  },
});
